import { create } from 'zustand';

type ModalDirection = 'top' | 'bottom' | 'left' | 'right' | 'center' | 'clip';

type ModalOverflowType = 'hidden' | 'auto' | 'scroll';

type ModalSize = {
    pcWidth?: string;
    mbWidth?: string;
    pcHeight?: string;
    mbHeight?: string;
};

type ModalItem = {
    id: string;
    component: React.ReactNode;
    size?: ModalSize;
    direction?: ModalDirection;
    borderColor?: string;
    overFlowType?: ModalOverflowType;
    zIndex?: number;
};

type ModalStore = {
    isOpen: boolean;
    currentModal: ModalItem | null;
    modalQueue: ModalItem[];
    openModal: (modal: ModalItem) => void;
    closeModal: () => void;
};

export const useModalStore = create<ModalStore>((set) => ({
    isOpen: false,
    currentModal: null,
    modalQueue: [],

    openModal: (modal: ModalItem) => {
        set((state) => {
            if (state.isOpen) {
                return { modalQueue: [...state.modalQueue, modal] };
            }
            return { isOpen: true, currentModal: modal };
        });
    },

    closeModal: () => {
        set((state) => {
            if (state.modalQueue.length > 0) {
                const nextModal = state.modalQueue[0];
                return {
                    currentModal: nextModal,
                    modalQueue: state.modalQueue.slice(1),
                };
            }
            return { isOpen: false, currentModal: null };
        });
    },
}));
